// Puerto de packages/hce/src/hce/useFarmaciaInternaHabilitada.ts — mismo
// cambio que useEspecialidadesHabilitadas.ts: useMedplum de @medplum/react-hooks.
import { useMedplum } from '@medplum/react-hooks';
import { useEffect, useState } from 'react';

const EXT_URL = 'http://logiacare.ec/fhir/farmacia-interna-habilitada';

export type EstadoFarmaciaInterna = { cargando: true } | { cargando: false; habilitada: boolean };

export function useFarmaciaInternaHabilitada(): EstadoFarmaciaInterna {
  const medplum = useMedplum();
  const [habilitada, setHabilitada] = useState<boolean>();

  useEffect(() => {
    let cancelado = false;
    medplum
      .searchOne('Organization', {})
      .then((org) => {
        if (cancelado) return;
        const ext = org?.extension?.find((e) => e.url === EXT_URL);
        setHabilitada(ext?.valueBoolean === true);
      })
      .catch(() => {
        if (!cancelado) setHabilitada(false);
      });
    return () => {
      cancelado = true;
    };
  }, [medplum]);

  if (habilitada === undefined) {
    return { cargando: true };
  }
  return { cargando: false, habilitada };
}
